import { useSelector } from "react-redux";
import styles from './DropdownFilter.module.css';

export default function DropdownFilter({ handleSelect, seriesIds, label, value, column, filterBy, className }) {

  // get data from Redux state
  const data = useSelector((state) => {
    const ids = Array.isArray(seriesIds) ? seriesIds : [seriesIds];
    // Combine all products from all series into a single array
    return ids.flatMap((id) => {
      const seriesData = state.visualizer.productDataBySeries[id];
      return seriesData ? Object.values(seriesData) : [];
    });
  }) || [];
  
  // Apply filtering if filterBy is provided
  let filteredData = data;
  
  if (filterBy) {
    filteredData = filteredData.filter(item => {
      return Object.entries(filterBy).every(([key, val]) => {
        // Skip if filter value is -1 (All)
        if (val === -1 || val === '-1') return true;
        return item[key] === val;
      });
    });
  }
  
  // ensure unique dropdown options
  const uniqueOptions = [...new Set(filteredData.map(d => d[column]).filter(Boolean))];



  const dropdownOptions = uniqueOptions.map((option, index) => (
    <option key={index} value={option} defaultValue={value === option}>
      {option}
    </option>
  ));

  return (
    <select
      name={column}
      className={`${styles.dropdown} ${className || ''}`}
      value={value}
      onChange={handleSelect}
    >
      <option value="-1">All {label}</option>
      {dropdownOptions}
    </select>
  );
}
